import { useDispatch } from 'react-redux';
import { Drawer, DrawerClose, DrawerContent } from "../../ui/drawer";
import styles from './A23TournamentPrizeDrawer.module.css';
import { 
  useOpenTourneyWinnerModal,
  useTourneyPrizeDetails,
  useTourneyGameCompleted
} from '@/src/hooks/data/useGameTable';
import { checkToDisplayValueInK, checkToDisplayValueInL, parseDecimalValuesOfNumber } from '../../../../Common/utils/GameUtils';
import { IoCloseSharp } from 'react-icons/io5';
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import { deleteGameTable } from '@/Poker/redux/slices/gameTableSlice';
import { useNavigate } from 'react-router';
import useActiveGames from '@/src/hooks/data/useActiveGames';

function A23TournamentPrizeDrawer({ tempTableId }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const activeGames = useActiveGames();
    const openTourneyWinnerModal = useOpenTourneyWinnerModal(tempTableId);
    const tourneyPrizeDetails = useTourneyPrizeDetails(tempTableId);
    const tourneyGameCompleted = useTourneyGameCompleted(tempTableId);
    const { triggerExitTableFlow } = useGameSocket(tempTableId);

    const handleOutsideClick = () => {

    }

    // const handleCloseMark = () => {
    //     if (activeGames.length === 1) {
    //         navigate(-1, { replace: true });
    //     } else {
    //         dispatch(deleteGameTable({ tempTableId }));
    //     }
    // }

    const goToLobby = () => {
        if (!tourneyPrizeDetails?.tourneyEnded) {
            return triggerExitTableFlow();
        }
        if (activeGames.length === 1) {
            navigate(-1, { replace: true });
        }
        dispatch(deleteGameTable({ tempTableId }));
    }

    if (!openTourneyWinnerModal) {
        return null;
    }

    const hasWinnings = tourneyPrizeDetails?.playerWinning > 0;
    const hasBountyWinnings = tourneyPrizeDetails?.bountyWinnings > 0;
    const hasTicketWon = Object.keys(tourneyPrizeDetails?.ticketWonDetails || {}).length > 0;
    const hasFlightChildWinner = Object.keys(tourneyPrizeDetails?.flightChildWinnerAck || {}).length > 0;
    const hasKnockedOutPlayers = tourneyPrizeDetails?.noOfKnockedOutPlayers > 0;
    const hasBountyTourneyTotal = tourneyPrizeDetails?.bountyTourneyTotalWinnings > 0;

    return (
        <Drawer dismissible={false} open={openTourneyWinnerModal}>
            <DrawerContent draggable={false} showCloseButton={false} onInteractOutside={handleOutsideClick} side="bottom" className={styles.container}>
                {/* Header with centered title and close button */}
                <div className={styles.header}>
                    <div className={styles.headerSpacer}></div>
                    <h2 className={styles.title}>Congratulations</h2>
                    {/* {
                        !tourneyPrizeDetails?.tourneyEnded ?
                            <DrawerClose onClick={handleCloseMark} className={styles.closeButton}>
                                <IoCloseSharp className={styles.closeIcon} />
                            </DrawerClose>
                            : null
                    } */}
                </div>

                <div className={styles.content}>
                    <div className={styles.messageContainer}>
                        <p className={styles.messageText}>
                            You have finished the tournament in place&nbsp;
                            <span className={styles.rankHighlight}>
                                {tourneyPrizeDetails?.rank > 0 && `#${tourneyPrizeDetails.rank}`}
                            </span>
                        </p>

                        {hasWinnings && (
                            <div className={styles.prizeAmount}>
                                {`₹${parseDecimalValuesOfNumber(
                                    tourneyPrizeDetails?.playerWinning,
                                    2,
                                    checkToDisplayValueInK(tourneyPrizeDetails?.playerWinning),
                                    checkToDisplayValueInL(tourneyPrizeDetails?.playerWinning)
                                )}`}
                            </div>
                        )}

                        {hasBountyWinnings && (
                            <div className={styles.bountyAmount}>
                                <div className={styles.bountyLabel}>Bounty Earned</div>
                                <div className={styles.bountyValue}>
                                    {`₹${parseDecimalValuesOfNumber(
                                        tourneyPrizeDetails?.bountyWinnings,
                                        2,
                                        checkToDisplayValueInK(tourneyPrizeDetails?.bountyWinnings),
                                        checkToDisplayValueInL(tourneyPrizeDetails?.bountyWinnings)
                                    )}`}
                                </div>
                            </div>
                        )}

                        {hasKnockedOutPlayers && (
                            <div className={styles.knockedOutPlayersCard}>
                                <div className={styles.knockedOutPlayersLabel}>Players Eliminated</div>
                                <div className={styles.knockedOutPlayersValue}>
                                    {tourneyPrizeDetails?.noOfKnockedOutPlayers}
                                </div>
                            </div>
                        )}

                        {hasBountyTourneyTotal && (
                            <div className={styles.bountyTourneyTotalCard}>
                                <div className={styles.bountyTourneyTotalLabel}>Total Bounty Winnings</div>
                                <div className={styles.bountyTourneyTotalValue}>
                                    {`₹${parseDecimalValuesOfNumber(
                                        tourneyPrizeDetails?.bountyTourneyTotalWinnings,
                                        2,
                                        checkToDisplayValueInK(tourneyPrizeDetails?.bountyTourneyTotalWinnings),
                                        checkToDisplayValueInL(tourneyPrizeDetails?.bountyTourneyTotalWinnings)
                                    )}`}
                                </div>
                            </div>
                        )}

                        {(hasTicketWon || hasFlightChildWinner) && (
                            <div className={styles.ticketSection}>
                                {hasWinnings && (hasTicketWon || hasFlightChildWinner) && (
                                    <p className={styles.conjunction}>and</p>
                                )}

                                {hasTicketWon && (
                                    <div className={styles.ticketCard}>
                                        <div className={styles.ticketLabel}>Ticket Won</div>
                                        <div className={styles.ticketTourneyName}>
                                            {tourneyPrizeDetails?.ticketWonDetails?.tourneyName || "Unknown Tourney"}
                                        </div>
                                        <div className={styles.ticketDescription}>
                                            Tournament Entry Ticket
                                        </div>
                                    </div>
                                )}

                                {hasFlightChildWinner && (
                                    <div className={styles.ticketCard}>
                                        <div className={styles.ticketLabel}>Flight Winner Ticket</div>
                                        <div className={styles.ticketTourneyName}>
                                            {tourneyPrizeDetails.flightChildWinnerAck?.destinationTourneyName || "Unknown Tourney"}
                                        </div>
                                        <div className={styles.ticketDescription}>
                                            Flight Winner Tournament Entry
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <button
                        className={styles.actionButton}
                        onClick={goToLobby}
                    >
                        Go To Lobby
                    </button>
                </div>
            </DrawerContent>
        </Drawer>
    );
}

export default A23TournamentPrizeDrawer;